import MousetrapModule from 'mousetrap';
import mousetrapPause from 'mousetrap-pause';

/**
 * Mousetrap module with mousetrap-pause module installed
 */
export const Mousetrap = mousetrapPause(MousetrapModule) as typeof MousetrapModule & {
    pause: Function;
    unpause: Function;
};
